import { css } from "@emotion/css";

import { grey, white, yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export function createTutorialDetailsPageStyles({
  borderRadius,
  spacing,
  palette,
  typography,
}: Theme) {
  return {
    detailsItem: css({
      display: "flex",
      color: grey[950],
      marginRight: spacing(4),
    }),
    detailLayoutBox: css({
      paddingBottom: spacing(12.5),
    }),
    totalStepsNumber: css({
      color: grey[600],
    }),
    paragraph: css({
      whiteSpace: "pre-line",
      lineHeight: "normal",
      marginBottom: spacing(2),
      fontSize: typography.fontSize.default,
      fontFamily: typography.fonts.content,
      color: grey[650],
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      minHeight: 400,
    }),
    buttonsWrapper: css({
      position: "fixed",
      bottom: 0,
      left: 0,
      background: white,
      width: "100%",
      padding: spacing([2, 3]),
      display: "grid",
      gridAutoFlow: "column",
      gap: spacing(3),
    }),
    button: css({
      display: "flex",
    }),
    arrow: css({
      position: "absolute",
      right: 16,
      "@media (max-width: 360px)": {
        display: "none",
      },
    }),
    aspectRatio: css({
      maxWidth: 700,
      backgroundColor: palette.secondary.light,
      borderRadius: borderRadius.medium,
      margin: `${spacing(2)} auto`,
    }),
    iframe: css({
      // safari needs a border radius directly
      //on the iframe
      borderRadius: borderRadius.medium,
    }),
    contentWrapper: css({
      color: grey[650],
    }),
    handbookLink: css({
      display: "grid",
      gridAutoFlow: "column",
      gap: spacing(1),
      marginBottom: spacing(2),
      justifyContent: "start",
      alignItems: "center",
      textDecoration: "none",
      wordBreak: "break-all",
      fontWeight: typography.fontWeight.semiBold,
    }),
  };
}
